import { z } from 'zod';
import { DataSelector } from '../types/segment';
import { DataSource } from '../types/enums/data_source';
// import jsonata from 'jsonata';

const dataSelectorSchema = z
	.object({
		name: z.string().min(3, 'Name must be at least 3 characters long'),
		description: z.string().min(3, 'Description must be at least 3 characters long'),
		fieldName: z.string().min(3, 'Field name must be at least 3 characters long'),
		isJsonQuery: z.boolean().optional(),
	})
	.superRefine((data, ctx) => {
		if (!data.isJsonQuery) return;

		let parsed;

		try {
			parsed = JSON.parse(data.fieldName);
		} catch {
			ctx.addIssue({
				path: ['fieldName'],
				code: z.ZodIssueCode.custom,
				message: 'Invalid JSON format in fieldName. Ensure the fieldName is a valid JSON string without multiline text or syntax errors.',
			});
			return;
		}

		if (!parsed.Query || typeof parsed.Query !== 'string') {
			ctx.addIssue({
				path: ['fieldName'],
				code: z.ZodIssueCode.custom,
				message: 'Missing or invalid "Query" field.',
			});
			return;
		}

		// Validate Variables field
        if (!parsed.Variables || !Array.isArray(parsed.Variables)) {
            ctx.addIssue({
                path: ['fieldName'],
                code: z.ZodIssueCode.custom,
                message: 'Missing or invalid "Variables" field. Must be an array.',
            });
            return;
        }

        // Validate each variable in the Variables array
        for (let index = 0; index < parsed.Variables.length; index++) {
            const variable = parsed.Variables[index];
            
            if (!variable || typeof variable !== 'object') {
                ctx.addIssue({
                    path: ['fieldName'],
                    code: z.ZodIssueCode.custom,
                    message: `Variable at index ${index} must be an object.`,
                });
                continue;
            }

            if (!variable.UiName || typeof variable.UiName !== 'string') {
                ctx.addIssue({
                    path: ['fieldName'],
                    code: z.ZodIssueCode.custom,
                    message: `Variable at index ${index} is missing or has invalid "UiName" field.`,
                });
            }

			if (!variable.Type || typeof variable.Type !== 'string') {
                ctx.addIssue({
                    path: ['fieldName'],
                    code: z.ZodIssueCode.custom,
                    message: `Variable at index ${index} is missing or has invalid "Type" field.`,
                });
            }

            if (!variable.QueryName || typeof variable.QueryName !== 'string') {
                ctx.addIssue({
                    path: ['fieldName'],
                    code: z.ZodIssueCode.custom,
                    message: `Variable at index ${index} is missing or has invalid "QueryName" field.`,
                });
            }

            if (variable.DefaultValue === undefined) {
                ctx.addIssue({
                    path: ['fieldName'],
                    code: z.ZodIssueCode.custom,
                    message: `Variable at index ${index} is missing "DefaultValue" field.`,
                });
            }
        }
		/* 		try {
			jsonata(parsed.Query);
			console.log(jsonata(parsed.Query));
		} catch (error) {
			ctx.addIssue({
				path: ['fieldName'],
				code: z.ZodIssueCode.custom,
				message: 'Invalid JSONata expression in query.',
			});
		} */
	});

export default dataSelectorSchema;
